import { Box, Typography } from '@mui/material';

export const OrganizationSettingsPage = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Organization Settings
      </Typography>
      <Typography color="text.secondary">
        Organization configuration coming soon...
      </Typography>
    </Box>
  );
};
